module.exports = __webpack_public_path__ + "img/sewing-machine.00e35ce5.svg";